import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'
import { navTheme } from 'styles/global'

export const BoxDiv = styled.div`
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    background-color: #161616a3;
    padding-top: 3.6875rem;
    padding-bottom: 3.125rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        padding-top: 6.9375rem;
    }
`
export const ContentDiv = styled.div`
    width: 20.5rem;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.whites[100]};
    border-radius: 1rem;
    padding: 2rem;
    margin: 0 auto;

    p {
        font-family: ${navTheme.fonts.base};
        text-align: center;
    }

    img#logo-nav {
        width: 6rem;
        height: 1.5rem;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 33rem;

        img#logo-nav {
            height: 2rem;
        }
    }
`
export const Title = {
    fontWeight: 700,
    fontSize: '1.25rem',
    fontFamily: navTheme.fonts.base,
    textAlign: 'center',
    lineHeight: '1.5rem',
    marginBottom: '0.5rem',
} as const

export const SmallParagraph = {
    fontSize: ['0.875rem', '1rem'],
}

export const ContainerGif = styled.div`
    width: 3.5rem;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    margin: 1.5rem 0;

    img#gif-style {
        height: 3.5rem;
        transform: rotate(0);
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 3rem;
        flex-direction: row;
        margin: 0 1.5rem;

        img#gif-style {
            transform: rotate(-90deg);
        }
    }
`

export const ImagesDiv = styled.div`
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    & {
        img:nth-child(2) {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 3rem;
        flex-direction: row;
    }
`

export const ButtonDiv = styled.div`
    margin-top: 1rem;
`

export const ButtonStyled = {
    width: ['16.5rem', '23.75rem'],
}
